import type { ReactNode } from "react"
import Select from "@mui/material/Select"
import { makeStyles } from "tss-react/mui"

import { LabeledField } from "../../../../../../shared/components/forms/LabeledField"

type LabeledFilterSelectProps = Readonly<{
    id: string
    label: string
    value: string
    onChange: (value: string) => void
    children: ReactNode
    className?: string
    selectClassName?: string
}>

const useStyles = makeStyles()((theme) => ({
    select: {
        borderRadius: ".75rem",
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.tailwind.slate[300],
        },
    },
}))

export function LabeledFilterSelect({
    id,
    label,
    value,
    onChange,
    children,
    className,
    selectClassName,
}: LabeledFilterSelectProps) {
    const { classes, cx } = useStyles()

    return (
        <LabeledField label={label} bold={false} gap=".25rem" className={className}>
            <Select
                id={id}
                value={value}
                onChange={(event) => onChange(event.target.value)}
                className={cx(classes.select, selectClassName)}
                fullWidth
            >
                {children}
            </Select>
        </LabeledField>
    )
}

